import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EmailTemplate, EmailTemplates } from 'Interfaces/EmailTemplateInterface';

const INITIAL_STATE: EmailTemplates = [];

const emailTemplatesSlice = createSlice({
  name: 'emailTemplates',
  initialState: INITIAL_STATE,
  reducers: {
    loadedEmailTemplates(state, action: PayloadAction<EmailTemplates>) {
      return action.payload;
    },
    addEmailTempate(state, action: PayloadAction<EmailTemplate>) {
      return state.concat([action.payload]);
    },
    removeEmailTemplate(state, action: PayloadAction<number>) {
      return state.filter(e => e.id !== action.payload);
    }
  },
});
export const { loadedEmailTemplates, addEmailTempate, removeEmailTemplate } = emailTemplatesSlice.actions;
export default emailTemplatesSlice.reducer;
